<!--
首页热门图标

使用说明：

<HotIcon
 :items="[{img: '图片路径', text: '标题', link: '点击跳转路径'}]"
 />

-->

<template>
  <div class="wrap">
    <div class="icon-list">
      <div
        class="icon-item"
        v-for="(item, index) in items"
        :key="item.img"
        @click="goto(item.link)"
        v-if="index < indexValue"
      >
        <Icon class="icon" :img="item.img" size="contain" />
        <div class="text">{{item.text}}</div>
      </div>

      <!-- 大玩家用户隐藏这个功能 -->
      <template v-if="!easyUser">
        <div class="icon-item" @click="goto(localShopUrl)" v-if="localShopUrl">
          <Icon class="icon" :img="merchant" size="contain" />
          <div class="text">周边商家</div>
        </div>
      </template>

      <!-- <div class="icon-item" @click="goto('/pages/products/List?affordable=1')">
                <Icon class="icon" :img="hotIconAfforable" size="contain"/>
                <div class="text">我能兑换</div>
      </div>-->

      <!-- 文化积分直充 -->
      <template v-if="jifentongChargeEnable">
        <div class="icon-item" @click="goto('/pages/wenhuajifen/Charge')">
          <Icon class="icon" :img="hotIconWenhuajifen" size="contain" />
          <div class="text">公共积分</div>
        </div>
      </template>

      <!-- 话费直充 -->
      <template v-if="!easyUser">
        <template v-if="phoneChargeEnable">
          <div class="icon-item" @click="goto('/pages/charge/MobileCharge')">
            <Icon class="icon" :img="hotIconCharge" size="contain" />
            <div class="text">话费直充</div>
          </div>
        </template>
      </template>

      <!-- 大玩家用户隐藏这个功能 -->
      <!-- <template v-if="!easyUser">
        <div class="icon-item" @click="gotoLottery">
          <Icon class="icon" :img="hotIconGame" size="contain" />
          <div class="text">积分转盘</div>
          <div class="red" v-if="reddot"></div>
        </div>
      </template> -->


      <div class="icon-item" @click="goto('/pages/products/List')">
        <Icon class="icon" :img="hotIconCates" size="contain" />
        <div class="text">全部</div>
      </div>
    </div>
  </div>
</template>

<script>
const hotIconAfforable = require("../../assets/icon-hoticon-afforable.png");
const hotIconCates = require("../../assets/icon-hoticon-cates.png");
const hotIconGame = require("../../assets/icon-hoticon-game.png");
const hotIconCharge = require("../../assets/icon-hoticon-charge.png");
const merchant = require("../../assets/icon-hoticon-merchant.png");
const hotIconWenhuajifen = require("../../assets/icon-hoticon-wenhuajifen.png");


import api from "../../api";
import store from "../../api/store";

export default {
  props: ["items", "reddot"],
  data() {
    return {
      hotIconAfforable,
      hotIconCates,
      hotIconGame,
      merchant,
      hotIconCharge,
      hotIconWenhuajifen,
      localShopUrl: "",
      easyUser: store.loginedUser.easyUser,
      phoneChargeEnable: false,
      jifentongChargeEnable: false,
      allIndex: 10,
    };
  },
  computed: {
    indexValue() {
      var _count = 1;
      if (this.easyUser) {
        return (this.allIndex - _count);
      } else {
        if (this.localShopUrl) {
          _count += 1
        }
        if (this.phoneChargeEnable) {
          _count += 1
        }
        if (this.jifentongChargeEnable) {
          _count += 1
        }
        return (this.allIndex - _count);
      }
    }
  },
  methods: {
    goto(link) {
      if (link.startsWith("http")) {
        window.location.href = link;
      } else {
        this.$routerPush(this, link);
      }
    },
    gotoLottery() {
      var url = process.env.lotteryLoginUrl;
      location.href = url;
    }
  },
  mounted() {
    let localShopUrl = store.loginedUser.localShopUrl;
    if (localShopUrl) {
      this.localShopUrl = localShopUrl;
    }
    // 获取话费直充开关
    this.phoneChargeEnable = store.loginedUser.phoneChargeEnable
    // 获取积分通直充开关
    this.jifentongChargeEnable = store.loginedUser.jifentongChargeEnable
  }
};
</script>

<style lang="less" scoped>
.wrap {
}

.icon-list {
  font-size: 0;
  text-align: center;
  padding: 4vw 0 2vw;
  display: flex;
  flex-wrap: wrap;

  .icon-item {
    display: inline-block;
    width: 100vw / 5 - 0.5vw;
    margin: 1.7vw 0;
    position: relative;
    .icon {
      width: 13vw;
      height: 13vw;
    }

    .text {
      font-size: 2.93vw;
    }
  }
}

.red {
  position: absolute;
  top: 1vw;
  right: 1vw;
  z-index: 999;
  width: 2vw;
  height: 2vw;
  background: #ff0000;
  border-radius: 50%;
}
</style>





// WEBPACK FOOTER //
// src/components/homepage/HotIcon.vue